/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.27
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { IPagedCollectionFromJSON, IPagedCollectionToJSON, PhotographFromJSON, PhotographToJSON, } from './';
export function PhotographPagedCollectionApiResponseFromJSON(json) {
    return PhotographPagedCollectionApiResponseFromJSONTyped(json, false);
}
export function PhotographPagedCollectionApiResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'pagination': !exists(json, 'pagination') ? undefined : IPagedCollectionFromJSON(json['pagination']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'generatedDateTime': !exists(json, 'generatedDateTime') ? undefined : (new Date(json['generatedDateTime'])),
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : json['data'].map(PhotographFromJSON)),
    };
}
export function PhotographPagedCollectionApiResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'pagination': IPagedCollectionToJSON(value.pagination),
        'message': value.message,
        'generatedDateTime': value.generatedDateTime === undefined ? undefined : (value.generatedDateTime.toISOString()),
        'data': value.data === undefined ? undefined : (value.data === null ? null : value.data.map(PhotographToJSON)),
    };
}
